// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oI5Z","questions":"styles_questions__2B685","footer":"styles_footer__2Gvgt"};